import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import { Notifications } from '@mantine/notifications';
import './index.css';
import '@mantine/notifications/styles.css';
import { AppProvider, useAppContext } from './context/AppState/AppContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
   <AppProvider>
      <WrappedApp />
   </AppProvider>
);


export default function WrappedApp() {
   const { theme } = useAppContext();
   return (
      <MantineProvider theme={theme} defaultColorScheme="dark">
         <Notifications zIndex={1000} />
         <App />
      </MantineProvider>
   )
}
